import { Theme } from 'morpheus-ui';
import { tv } from 'tailwind-variants';

const borderWidthKeys = Object.keys(Theme.borderWidth);
export const ContentWrapper = tv(
  {
    base: 'text-mono-color-black group w-full flex flex-col between gap-sm bg-color-lightest dark:bg-[#2E3847] rounded-md shadow-level-2 px-4 py-3 cursor-pointer',
    variants: {
      color: {
        interdisciplinar:
          'hover:bg-disciplina-interdisciplinar transition ease-in-out delay-100 hover:text-card-color-default',
        redacao:
          'hover:bg-disciplina-redacao transition ease-in-out delay-100 hover:text-card-color-default',
        literatura:
          'hover:bg-disciplina-literatura transition ease-in-out delay-100 hover:text-card-color-default',
        espanhol:
          'hover:bg-disciplina-espanhol transition ease-in-out delay-100 hover:text-card-color-default',
        ingles:
          'hover:bg-disciplina-ingles transition ease-in-out delay-100 hover:text-card-color-default',
        portugues:
          'hover:bg-disciplina-portugues transition ease-in-out delay-100 hover:text-card-color-default',
        gramatica:
          'hover:bg-disciplina-portugues transition ease-in-out delay-100 hover:text-card-color-default',
        sociologia:
          'hover:bg-disciplina-sociologia transition ease-in-out delay-100 hover:text-card-color-default',
        filosofia:
          'hover:bg-disciplina-filosofia transition ease-in-out delay-100 hover:text-card-color-default',
        geografia:
          'hover:bg-disciplina-geografia transition ease-in-out delay-100 hover:text-card-color-default',
        historia:
          'hover:bg-disciplina-historia transition ease-in-out delay-100 hover:text-card-color-default',
        matematica:
          'hover:bg-disciplina-matematica transition ease-in-out delay-100 hover:text-card-color-default',
        fisica:
          'hover:bg-disciplina-fisica transition ease-in-out delay-100 hover:text-card-color-default',
        quimica:
          'hover:bg-disciplina-quimica transition ease-in-out delay-100 hover:text-card-color-default',
        biologia:
          'hover:bg-disciplina-biologia transition ease-in-out delay-100 hover:text-card-color-default',
        default: '',
      },
      selected: {
        true: 'border-hairline border-brand-color-primary-pure',
      },
    },
  },
  {
    twMergeConfig: {
      theme: {
        borderWidth: borderWidthKeys,
      },
    },
  }
);

export const IconDone = tv({
  base: 'text-lg filled transition delay-100 ease-in-out',
  variants: {
    type: {
      seen: 'text-brand-color-primary-pure group-hover:text-card-color-default',
      unseen: 'text-mono-color-medium',
    },
  },
});

export const IconFav = tv({
  base: 'p-0 text-lg filled transition delay-100 ease-in-out',
  variants: {
    type: {
      favorite: 'text-brand-color-secondary-pure',
      notFavorite: 'text-mono-color-medium',
    },
  },
});

export const SubjectTag = tv({
  base: 'flex flex-row items-center gap-sm px-2 text-mono-color-white',
  variants: {
    color: {
      interdisciplinar:
        'group-hover:text-disciplina-interdisciplinar transition ease-in-out delay-100 group-hover:bg-card-color-default',
      redacao:
        'group-hover:text-disciplina-redacao transition ease-in-out delay-100 group-hover:bg-card-color-default',
      literatura:
        'group-hover:text-disciplina-literatura transition ease-in-out delay-100 group-hover:bg-card-color-default',
      espanhol:
        'group-hover:text-disciplina-espanhol transition ease-in-out delay-100 group-hover:bg-card-color-default',
      ingles:
        'group-hover:text-disciplina-ingles transition ease-in-out delay-100 group-hover:bg-card-color-default',
      portugues:
        'group-hover:text-disciplina-portugues transition ease-in-out delay-100 group-hover:bg-card-color-default',
      gramatica:
        'group-hover:text-disciplina-portugues transition ease-in-out delay-100 group-hover:bg-card-color-default',
      sociologia:
        'group-hover:text-disciplina-sociologia transition ease-in-out delay-100 group-hover:bg-card-color-default',
      filosofia:
        'group-hover:text-disciplina-filosofia transition ease-in-out delay-100 group-hover:bg-card-color-default',
      geografia:
        'group-hover:text-disciplina-geografia transition ease-in-out delay-100 group-hover:bg-card-color-default',
      historia:
        'group-hover:text-disciplina-historia transition ease-in-out delay-100 group-hover:bg-card-color-default',
      matematica:
        'group-hover:text-disciplina-matematica transition ease-in-out delay-100 group-hover:bg-card-color-default',
      fisica:
        'group-hover:text-disciplina-fisica transition ease-in-out delay-100 group-hover:bg-card-color-default',
      quimica:
        'group-hover:text-disciplina-quimica transition ease-in-out delay-100 group-hover:bg-card-color-default',
      biologia:
        'group-hover:text-disciplina-biologia transition ease-in-out delay-100 group-hover:bg-card-color-default',
      default: '',
    },
  },
});
